export const DELETE_BROADCAST_EMAILS = 'DELETE_BROADCAST_EMAILS';
export const DELETE_BROADCAST_EMAILS_START = 'DELETE_BROADCAST_EMAILS_START';
export const DELETE_BROADCAST_EMAILS_SUCCESS = 'DELETE_BROADCAST_EMAILS_SUCCESS';
export const DELETE_BROADCAST_EMAILS_ERROR = 'DELETE_BROADCAST_EMAILS_ERROR';
